// src/App.js
import React, { useState } from 'react';

// --- Imports for your actual chain-specific application components ---
import EthApp from './chain/eth/App';
import UsdtApp from './chain/usdt/App';
import SolApp from './chain/sol/App';

// --- Base64 Encoded SVG Logos (Self-contained for simplicity) ---
const ethLogo = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIHZlcnNpb249IjEuMSIgc2hhcGUtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iIHRleHQtcmVuZGVyaW5nPSJnZW9tZXRyaWNQcmVjaXNpb24iIGltYWdlLXJlbmRlcmluZz0ib3B0aW1pemVRdWFsaXR5IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iMCAwIDc4NC4zNyAxMjc3LjM5IiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sbnM6eG9kbT0iaHR0cDovL3d3dy5jb3JlbC5jb20vY29yZWxkcmF3L29kbS8yMDAzIj4gPGcgaWQ9IkxheWVyX3gwMDIwXzEiPiA8bWV0YWRhdGEgaWQ9IkNvcmVsQ29ycElEXzBDb3JlbC1MYXllciIvPiA8ZyBpZD0iXzE0MjEzOTQzNDI0MDAiPiA8Zz4gPHBvbHlnb24gZmlsbD0iIzM0MzQzNCIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjM5Mi4wNywwIDM4My41LDI5LjExIDM4My41LDg3My43NCAzOTIuMDcsODgyLjI5IDc4NC4xMyw2NTAuNTQgIi8+IDxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9lbnRzPSIzOTIuMDcsMCAtMCw2NTAuNTQgMzkyLjA3LDg4Mi4yOSAzOTIuMDcsNDcyLjMzICIvPiA8cG9seWdvbiBmaWxsPSIjM0MzQzNCIiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iMzkyLjA3LDk1Ni41MiAzODcuMjQsOTYyLjQxIDM4Ny4yNCwxMjYzLjI4IDM5Mi4wNywxMjc3LjM4IDc4NC4zNyw3MjQuODkgIi8+IDxwb2x5Z29uIGZpbGw9IiM4QzhDOEMiIGZpbGwtcnVsZT0ibm9uemVybyIgcG9lbnRzPSIzOTIuMDcsMTI3Ny4zOCAzOTIuMDcsOTU2LjUyIC0wLDcyNC44OSAiLz4gPHBvbHlnb24gZmlsbD0iIzE0MTQxNCIgZmlsbC1ydWxlPSJub256ZXJvIiBwb2ludHM9IjM5Mi4wNyw4ODIuMjkgNzg0LjEzLDY1MC41NCAzOTIuMDcsNDcyLjMzICIvPiA8cG9seWdvbiBmaWxsPSIjMzkzOTM5IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHBvaW50cz0iMCw2NTAuNTQgMzkyLjA3LDg4Mi4yOSAzOTIuMDcsNDcyLjMzICIvPiA8L2c+IDwvZz4gPC9nPiA8L3N2Zz4=';
const usdtLogo = 'data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMzkuNDMgMjk1LjI3Ij48dGl0bGU+dGV0aGVyLXVzZHQtbG9nbzwvdGl0bGU+PHBhdGggZD0iTTYyLjE1LDEuNDVsLTYxLjg5LDEzMGEyLjUyLDIuNTIsMCwwLDAsLjU0LDIuOTRMMTY3Ljk1LDI5NC41NmEyLjU1LDIuNTUsMCwwLDAsMy41MywwTDMzOC42MywxMzQuNGEyLjUyLDIuNTIsMCwwLDAsLjU0LTIuOTRsLTYxLjg5LTEzMEEyLjUsMi41LDAsMCwwLDI3NSwwSDY0LjQ1YTJeLjUsMi41LDAsMCwwLTIuMywxLjQ1aDBaIiBzdHlsZT0iZmlsbDojNTBhZjk1O2ZpbGwtcnVsZTpldmVub2RkIi8+PHBhdGggZD0iTTE5MS4xOSwxNDQuOHYwYzEuMiwwLjA5LTcuNCwwLjQ2LTIxLjIzLDAuNDYtMTEsMC0xOC44MS0uMzMtMjEuNTUtMC40NnYwYy00Mi41MS0xLjg3LTc0LjI0LTkuMjctNzQuMjQtMTguMTNzMzEuNzMtMTYuMjUsNzQuMjQtMTguMTV2MjguOTFjMi43OCwwLjIsMTAuNzQsMC42NywyMS43NCwwLjY3LDEzLjIsMCwxOS44MS0uNTUsMjEtMC42NnYtMjguOWM0Mi40MiwxLjg5LDc0LjA4LDkuMjksNzQuMDgsMTguMTNzLTMxLjY1LDE2LjI0LTc0LjA4LDE4LjEyaDBabTAtMzkuMjVWNzkuNjhoNTkuMlY0MC4yM0g4OS4yMVY3OS42OGgxNTkuMnYyNS44NmMtNDguMTEsMi4yMS04NC4yOSwxMS43NC04NC4yOSwyMy4xNnMzNi4xOCwyMC45NCw4NC4yOSwyMy4xNnY4Mi45aDQyLjc4VjE1MS44M2M0OC0yLjIxLDg0LjEyLTExLjczLDg0LjEyLTIzLjE0cy0zNi4wOS0yMC45My04NC4xMi0yMy4xNWgwWm0wLDBoMFoiIHN0eWxlPSJmaWxsOiNmZmY7ZmlsbC1ydWxlOmV2ZW5vZGQiLz48L3N2Zz4=';
const solLogo = 'data:image/svg+xml;base64,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';
const iconShield = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNNi40NzUgMjEuNzI1Yy0uODUgMC0xLjYyNS0uMzUtMi4yNS0uOTc1cy0uOTc1LTEuNC0uOTc1LTIuMjVWOS4yMjVjMC0uODUuMzUtMS42MjUuOTc1LTIuMjUuNjI1LS42MjUgMS40LS45NzUgMi4yNS0uOTc1aDEuM3YtMS4zYzAtMS4zMjUuNDY5LTIuNDU2IDEuNDA2LTMuMzk0QzEwLjQxOS4yNjkgMTEuNTUgMCAxMi44NzUgMGMyLjYyNSAwIDQuNSAxLjg3NSA0LjUgNC41djIuNGgxLjVjLjg1LTAgMS42MjUuMzUgMi4yNS45NzVzLjk3NSAxLjQgLjk3NSAyLjI1djkuMjc1YzAgLjg1LS4zNSAxLjYyNS0uOTc1IDIuMjVzLTEuNCAuOTc1LTIuMjUuOTc1Wm02LjQtMTEuNWMuNDUgMCAuODI1LS4xNSAxLjEyNS0uNDVzLjQ1LS42NS40NS0xLjEyNWMwLS40NzUtLjE1LS44NS0uNDUtMS4xMjVTLTE5LjA1IDcuMSA4LjYgNy4xYy0uNDc1IDAtLjg2My4xNS0xLjE2My40NXMtLjQ1LjY1LS40NSAxLjEyNWMwIC40NzUuMTUgLjg1LjQ1IDEuMTI1cy42ODggLjQ1IDEuMTYzLjQ1Wm0tMS4zLTEzLjVoMi42MjVjLS4wMjUtLjc1LS4yNDQtMS4yMzgtLTY1Ni0xLjQ3NS0uNDEzLS4yMzctLjg1LS4zNTYtMS4zMTMtLjM1Ni0uNjUgMC0xLjIyNS4yMzEtMS43MjUuNjk0LS41LjQ2Mi0uNzUgMS4wNS0uNzUgMS43NTZ2MS40aDIuNjI1VjYuNzVaIi8+PC9zdmc+';
const iconChain = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNNy4xIDIxYy0xLjUgMC0yLjgxMy0uNTMxLTMuOTM4LTEuNTk0UzIgMTcuNiAyIDE2di0yLjFjMC0xLjUuNTMxLTIuODEzIDEuNTk0LTMuOTM4UzUuNiA4LjggNy4xIDguOGgzLjh2Mi4xSDcuMWMtLjY1 MCAxLjEuMjE5LTEuNTUuNjg4LS40NS40NjgtLjY4OCAxLjA1LS42ODggMS42ODh2Mi4xYzAgLjY1LjIzOCAxLjIzNy43MTMgMS43MTIuNDc1LjQ3NSAxLjA2Mi43MTIgMS43MTIuNzEyaDMuOHYyLjFINy4xWm01LjYyNS0zLjljLS4zLS4zLS4zODgtLjYyNS0uMjYzLS45NzUtLjExMy0uMzUtLjA4OC0uNjYzLjA4OC0uOTM4bDIuODUtMi44NWMuMy0uMy42MzgtLjM2MyAxLjAxMy0uMTg4LjM3NS4xNzUuNTYyLjQ3NS41NjIuOVYxM2gtMi4xdi0xLjVsLTEuNzUgMS43NWMtLjQuNC0uOC42LTEuMi42LS40IDAtLjgtLjItMS4yLS42Wm0tMi44IDIuOGMtLjQuNC0uOC42LTEuMi42LS40IDAtLjgtLjItMS4yLS42cy0uNi0uOC0uNi0xLjJjMC0uNDI1LjE3NS0uNzg4LjUyNS0xLjA4OEwxMy4yIDkuNWMuMy0uMy42MjUtLjM4Ny45NzUtLjI2Mi4zNS4xMjUuNjYzLjM1LjkzOC42NjNsMi44NSAyLjg1Yy4zLjMuMzYzLjYzOC4xODggMS4wMTItLjE3NS4zNzUtLjQ3NS41NjItLjkuNTYyaC0xLjdsLTEuNzUtMS43NWMtLjQuNC0uOC42LTEuMi42LS40IDAtLjgtLjItMS4yLS42Wm00LjE3NSA1LjZoLTEuN3YtMi4xaDEuN2MuNjUgMCAxLjIzOC0uMjM4IDEuNzEyLS43MTMuNDc1LS40NzUgLjcxMi0xLjA2Mi43MTItMS43MTJ2LTIuMWMwLS42NS0uMjM3LTEuMjM4LS43MTItMS43MTItLjQ3NS0uNDc1LTEuMDYyLS43MTItMS43MTItLjcxMmgtMS43VjYuN2gxLjdjMS41IDAgMi44MTMuNTMxIDMuOTM4IDEuNTk0UzIxIDEwLjQgMjEgMTJ2Mi4xYzAgMS41LS41MzEgMi44MTMtMS41OTQgMy45MzhTMTguNCAyMSAxNi45IDIxWiIvPjwvc3ZnPg==';
const iconBolt = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0iY3VycmVudENvbG9yIj48cGF0aCBkPSJNNi42IDE5LjV2LTdoLTJWMTVoMi4xdi00LjVoMS43bC0zLjggOUg4LjhsMy44LTloMS44djRoMi4xdi02LjVINy45bDQtMTBoMi41bC00IDEwWiIvPjwvc3ZnPg==';

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedChain, setSelectedChain] = useState(null);

  // This function renders the correct component based on the selected chain
  const renderChainComponent = () => {
    // Pass a disconnect function as a prop so child components can reset the state
    // NOTE: Your EthApp, UsdtApp, and SolApp components must accept an `onDisconnect` prop for this to work.
    const disconnectProps = { onDisconnect: () => setSelectedChain(null) };
    
    switch (selectedChain) {
      case "eth":
        return <EthApp {...disconnectProps} />;
      case "usdt":
        return <UsdtApp {...disconnectProps} />;
      case "sol":
        return <SolApp {...disconnectProps} />;
      default:
        return null;
    }
  };

  const pageStyles = `
    :root {
      --brand-gradient: linear-gradient(90deg, #007BFF, #00C6FF);
      --dark-bg: #0D1117;
      --light-text: #EAEAEA;
      --grey-text: #A0A0A0;
      --card-bg: rgba(22, 27, 34, 0.75);
      --card-border: rgba(255, 255, 255, 0.1);
      --glow-color: rgba(0, 198, 255, 0.5);
    }
    body {
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', sans-serif;
      -webkit-font-smoothing: antialiased;
      background-color: var(--dark-bg);
      color: var(--light-text);
    }
    .app-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      box-sizing: border-box;
      position: relative;
      z-index: 1;
    }

    /* --- FULL LANDING PAGE STYLES --- */
    .landing-page {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8rem; /* Space between sections */
      padding: 6rem 2rem;
      animation: fadeIn 1.2s ease-in-out;
    }
    .section {
      width: 100%;
      max-width: 1100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    .section-title {
      font-size: 2.5rem;
      font-weight: 700;
      margin-bottom: 1rem;
    }
    .section-subtitle {
      font-size: 1.1rem;
      color: var(--grey-text);
      max-width: 600px;
      margin-bottom: 3rem;
    }

    /* --- Hero Section --- */
    .hero-container {
      background: var(--card-bg);
      border: 1px solid var(--card-border);
      border-radius: 24px;
      padding: 3rem 4rem;
      backdrop-filter: blur(15px); -webkit-backdrop-filter: blur(15px);
      position: relative;
      box-shadow: 0 0 0 1px var(--card-border), 0 0 80px -20px rgba(0,0,0,0.5);
    }
     .hero-container::before {
      content: ''; position: absolute; top: 0; left: 0; right: 0; bottom: 0;
      border-radius: 24px; padding: 1px;
      background: linear-gradient(135deg, rgba(255,255,255,0.2), rgba(255,255,255,0));
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none;
    }
    .hero-title { font-size: 3.5rem; font-weight: 800; margin: 0 0 1rem 0; color: #FFFFFF; line-height: 1.1; }
    .hero-title .gradient-text {
      background: var(--brand-gradient); -webkit-background-clip: text;
      -webkit-text-fill-color: transparent; background-size: 200% auto;
      animation: gradient-shine 5s linear infinite;
    }
    .hero-subtitle { font-size: 1.25rem; color: var(--grey-text); margin: 0 0 2.5rem 0; line-height: 1.6; max-width: 500px; margin-left: auto; margin-right: auto; }
    
    /* --- Features Section --- */
    .features-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
      width: 100%;
    }
    .feature-card {
      background: rgba(22, 27, 34, 0.5); border: 1px solid var(--card-border);
      border-radius: 16px; padding: 2rem;
      transition: all 0.3s ease;
    }
    .feature-card:hover {
      transform: translateY(-8px);
      background: var(--card-bg);
      box-shadow: 0 8px 30px rgba(0,0,0,0.3);
    }
    .feature-icon {
      background: var(--brand-gradient);
      border-radius: 50%; width: 60px; height: 60px;
      display: flex; justify-content: center; align-items: center;
      margin: 0 auto 1.5rem auto;
    }
    .feature-icon img { width: 32px; height: 32px; }
    .feature-title { font-size: 1.25rem; font-weight: 600; margin-bottom: 0.5rem; }
    .feature-description { font-size: 1rem; color: var(--grey-text); line-height: 1.6; }

    /* --- Supported Networks Section --- */
    .networks-container { display: flex; gap: 4rem; justify-content: center; align-items: center; }
    .network-logo-item {
      opacity: 0.7;
      transition: all 0.3s ease;
      filter: grayscale(80%);
    }
    .network-logo-item:hover {
      opacity: 1;
      filter: grayscale(0%);
      transform: scale(1.1);
    }
    .network-logo-item img { height: 50px; }

    /* --- CTA Section --- */
    .cta-container {
      padding: 3rem; background: var(--card-bg);
      border: 1px solid var(--card-border); border-radius: 20px;
    }
    
    /* --- General Button & Shared Styles --- */
    .connect-button {
      background: var(--brand-gradient); color: white; border: none; border-radius: 12px;
      padding: 16px 32px; font-size: 1.1rem; font-weight: 600; cursor: pointer;
      transition: all 0.3s ease; box-shadow: 0 4px 20px rgba(0, 123, 255, 0.3);
      display: inline-flex; align-items: center; gap: 10px;
    }
    .connect-button:hover { transform: translateY(-4px); box-shadow: 0 8px 25px var(--glow-color); }
    .connect-button-icon { width: 22px; height: 22px; }

    /* --- Post-Connection Claim Page --- */
    .claim-page-container { width: 100%; max-width: 700px; animation: fadeIn 0.5s ease-in-out; } 
    .claim-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; padding-bottom: 1rem; border-bottom: 1px solid var(--card-border); } 
    .claim-title { margin: 0; font-size: 1.75rem; color: white; } 
    .disconnect-button { background: #333; color: var(--light-text); border: 1px solid #555; border-radius: 8px; padding: 10px 20px; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease; } 
    .disconnect-button:hover { background: #444; border-color: #777; } 
    .claim-box { background: rgba(0,0,0,0.2); border: 1px solid var(--card-border); border-radius: 16px; padding: 2.5rem; text-align: center; } 
    
    /* --- Modal --- */
    .modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.7); display: flex; justify-content: center; align-items: center; z-index: 1000; animation: fadeIn 0.3s ease-out; } 
    .modal-content { background: var(--card-bg); backdrop-filter: blur(15px); -webkit-backdrop-filter: blur(15px); border-radius: 20px; border: 1px solid var(--card-border); width: 90%; max-width: 420px; padding: 1.5rem 2rem; box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37); animation: slideIn 0.4s ease-out; } 
    .modal-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; color: #FFFFFF; } 
    .modal-header h2 { margin: 0; font-size: 1.5rem; } 
    .close-button { background: none; border: none; color: var(--grey-text); font-size: 2rem; cursor: pointer; line-height: 1; transition: color 0.2s ease; } 
    .close-button:hover { color: #FFFFFF; } 
    .network-options { display: flex; flex-direction: column; gap: 1rem; } 
    .network-button { display: flex; align-items: center; width: 100%; padding: 1rem; background-color: rgba(255, 255, 255, 0.05); border: 1px solid var(--card-border); border-radius: 12px; cursor: pointer; transition: all 0.2s ease; text-align: left; } 
    .network-button:hover { background-color: rgba(255, 255, 255, 0.15); transform: scale(1.02); } 
    .network-logo { width: 36px; height: 36px; object-fit: contain; margin-right: 1rem; } 
    .network-name { color: var(--light-text); font-size: 1.1rem; font-weight: 500; }
    
    /* --- Animations & Media Queries --- */
    @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
    @keyframes slideIn { from { transform: translateY(30px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
    @keyframes gradient-shine { to { background-position: 200% center; } }
    @media (max-width: 768px) { .features-grid { grid-template-columns: 1fr; } .hero-container { padding: 2rem; } .hero-title { font-size: 2.5rem; } }
  `;
  
  return (
    <>
      <style>{pageStyles}</style>
      <div className="app-container">
        {!selectedChain ? (
          // --- FULL LANDING PAGE VIEW ---
          <main className="landing-page">
            
            <section className="section hero-container">
              <h1 className="hero-title">Your Gateway to <span className="gradient-text">Digital Assets</span></h1>
              <p className="hero-subtitle">A seamless and secure experience to claim the latest token airdrops. Connect your wallet to unlock your rewards.</p>
              <button className="connect-button" onClick={() => setIsModalOpen(true)}>
                <svg className="connect-button-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 00-2.25-2.25H15a3 3 0 11-6 0H5.25A2.25 2.25 0 003 12m18 0v6a2.25 2.25 0 01-2.25-2.25H5.25A2.25 2.25 0 013 18v-6m18 0V9A2.25 2.25 0 0018.75 6.75h-1.5a3 3 0 00-6 0H6.75A2.25 2.25 0 004.5 9v3m15-3h-2.25a3 3 0 00-6 0H7.5" /></svg>
                Connect Wallet
              </button>
            </section>

            <section className="section">
              <h2 className="section-title">Why Choose Our Platform?</h2>
              <p className="section-subtitle">We provide a streamlined, safe, and efficient way to participate in token distributions across major blockchain networks.</p>
              <div className="features-grid">
                <div className="feature-card">
                  <div className="feature-icon"><img src={iconShield} alt="Security Icon" /></div>
                  <h3 className="feature-title">Secure & Reliable</h3>
                  <p className="feature-description">Your assets are always safe. We integrate with leading wallets and never request access to your private keys.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon"><img src={iconChain} alt="Multi-chain Icon" /></div>
                  <h3 className="feature-title">Multi-Chain Support</h3>
                  <p className="feature-description">Claim tokens on Ethereum, Solana, and more. Our platform is built to be interoperable and future-proof.</p>
                </div>
                <div className="feature-card">
                  <div className="feature-icon"><img src={iconBolt} alt="Instant Access Icon" /></div>
                  <h3 className="feature-title">Instant Access</h3>
                  <p className="feature-description">No complex steps. Connect your wallet, verify eligibility, and claim your airdrop in just a few simple clicks.</p>
                </div>
              </div>
            </section>

            <section className="section">
               <h2 className="section-title">Supported Networks</h2>
               <div className="networks-container">
                 <div className="network-logo-item"><img src={ethLogo} alt="Ethereum"/></div>
                 <div className="network-logo-item"><img src={usdtLogo} alt="Tether"/></div>
                 <div className="network-logo-item"><img src={solLogo} alt="Solana"/></div>
               </div>
            </section>

            <section className="section cta-container">
              <h2 className="section-title">Ready to Claim Your Rewards?</h2>
              <p className="section-subtitle">Connect your wallet now to get started. The future of decentralized rewards is just a click away.</p>
               <button className="connect-button" onClick={() => setIsModalOpen(true)}>Connect Wallet</button>
            </section>

          </main>
        ) : (
          // --- RENDER THE SELECTED CHAIN COMPONENT ---
          renderChainComponent()
        )}

        {/* --- THE MODAL (conditionally rendered) --- */}
        {isModalOpen && (
          <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header"><h2>Select Network</h2><button className="close-button" onClick={() => setIsModalOpen(false)}>&times;</button></div>
              <div className="network-options">
                <button className="network-button" onClick={() => { setSelectedChain('eth'); setIsModalOpen(false); }}><img src={ethLogo} alt="Ethereum" className="network-logo" /><span className="network-name">Ethereum</span></button>
                <button className="network-button" onClick={() => { setSelectedChain('usdt'); setIsModalOpen(false); }}><img src={usdtLogo} alt="Tether" className="network-logo" /><span className="network-name">Tether (USDT)</span></button>
                <button className="network-button" onClick={() => { setSelectedChain('sol'); setIsModalOpen(false); }}><img src={solLogo} alt="Solana" className="network-logo" /><span className="network-name">Solana</span></button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default App;